import { useMemo } from 'react';

import {
  AnimatedCameraControls,
  AnimatedCameraControlsProps,
  CameraControlsProps as BaseCameraControlsProps,
  createCameraAnimation,
  useDollhouse,
} from '@spazious/dollhouse-engine';
import { useStore } from '@spazious/dollhouse-store';
import { SurfacePathTravel } from '@spazious/dollhouse-three';
import { ControlsModeEnum } from '@spazious/dollhouse-types';
import { useEventCallback } from '@spazious/react-hooks';

export interface CameraControlsProps extends BaseCameraControlsProps {}

export const CameraTravelControls: React.FC<
  Omit<AnimatedCameraControlsProps, 'clip' | 'autoPlay'>
> = ({ onEnd, ...restProps }) => {
  const camera = useDollhouse(({ camera }) => camera);
  const world = useDollhouse(({ world }) => world);
  const set = useStore(({ set }) => set);

  const clip = useMemo(() => {
    if (!world?.navMesh) {
      return undefined;
    }
    return createCameraAnimation(
      camera,
      new SurfacePathTravel().setFromPositions(...world.navMesh.getDebugNavMesh())
    );
  }, [camera, world?.navMesh]);

  const handleEnd = useEventCallback(() => {
    onEnd?.();
    set({
      controls: ControlsModeEnum.Zenithal,
    });
  });

  return <AnimatedCameraControls autoPlay clip={clip} onEnd={handleEnd} {...restProps} />;
};
